import type { IconProps } from '@react-spectrum/s2';
import Briefcase from '@react-spectrum/s2/icons/Briefcase';
import Chat from '@react-spectrum/s2/icons/Chat';
import PeopleGroup from '@react-spectrum/s2/icons/PeopleGroup';
import Slideshow from '@react-spectrum/s2/icons/Slideshow';
import ViewGridFluid from '@react-spectrum/s2/icons/ViewGridFluid';
import type { FunctionComponent } from 'react';

import type { Space } from '../../../../bridge/types/state.ts';

export interface NavItemConfig {
	name: Space['type'] | 'chat';
	label: string;
	isPrimary?: boolean;
	isDisabled?: boolean;
	icon: FunctionComponent<IconProps>;
}

export const NAV_ITEMS: NavItemConfig[] = [
	{
		name: 'chat',
		label: 'Chat',
		isPrimary: true,
		icon: Chat,
	},
	{
		name: 'campaigns',
		label: 'Campaigns',
		icon: Slideshow,
	},
	{
		name: 'contacts',
		label: 'People',
		icon: PeopleGroup,
	},
	{
		name: 'brand',
		label: 'Brand',
		icon: Briefcase,
	},
	{
		name: 'content',
		label: 'Content',
		icon: ViewGridFluid,
	},
];
